{
  "until": "{{duration}} hadi {{prayer}}",
  "begin_focus": "Anza umakini",
  "add_task": "Ongeza kazi",
  "more_tasks": "+{{count}} zaidi",
  "fajr_at": "Alfajiri saa {{time}}",
  "schedule_title": "Leo",
  "plan_my_day": "Panga siku yangu",
  "planning": "Inapanga…",
  "suggested": "Imependekezwa",
  "keep_plan": "Weka mpango",
  "undo_plan": "Tengua",
  "plan_error": "Imeshindikana kupanga sasa. Jaribu tena.",
  "plan_empty": "Hakuna cha kupanga bado — ongeza kazi kwanza.",
  "plan_settled": "Kila kitu tayari kiko mahali pake.",
  "view_list": "Orodha",
  "view_switch_aria": "Badilisha kati ya mwonekano wa orodha na wa siku",
  "unassigned": "Hazijapangwa",
  "assign_title": "Kipindi cha swala",
  "no_block": "Hakuna kipindi",
  "assign_aria": "Weka kwenye kipindi cha swala",
  "open_schedule_aria": "Fungua ratiba ya leo",
  "focus_session_label": "{{block}} · Umakini",
  "block_hero": "Kazi ya kina hadi {{prayer}}",
  "moments_away": "{{prayer}} inakaribia sana",
  "block_clear": "Yote yamekamilika — pumzika hadi {{prayer}}",
  "alhamdulillah": "Alhamdulillah",
  "exit_hint": "Bonyeza Esc kutoka kimya kimya",
  "exit_hint_touch": "Gusa ✕ kutoka kimya kimya",
  "mark_done_aria": "Weka alama kazi imekamilika",
  "quick_add_placeholder": "Ongeza kwenye kipindi hiki…",
  "focus_task_aria": "Zingatia kazi hii"
}
